/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { object } from 'prop-types';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const useStyle = makeStyles((theme) => ({
    addonContainer: {
        background: '#EFF9F6',
        borderRadius: '3px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '16px',
        width: 'max-content',
    },
    addonSvg: {
        marginRight: '6px',
        padding: '4px 0px 4px 8px',
        '& > div': {
            width: '14px',
            [theme.breakpoints.up('600')]: {
                width: '16px',
                height: '20px',
            },
        },
        '& svg': {
            width: '8px',
            height: '14px',
            [theme.breakpoints.up('600')]: {
                width: '16px',
                height: '16px',
            },
        },
        '& img': {
            width: '100%',
        },

    },
    addonText: {
        fontSize: '12px',
        lineHeight: '16px',
        paddingRight: '8px',
        color: '#2B553B',
        letterSpacing: '0.5px',
        [theme.breakpoints.up('600')]: {
            fontSize: '14px',
            lineHeight: '19px',
        },
    },
}));
const AddonIcon = ({ addonsPresentation }) => {
    const classes = useStyle();

    const renderWineSvg = () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 15" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.666656 0.912411C0.666656 0.500594 0.99498 0.166748 1.39999 0.166748H7.08484C7.48985 0.166748 7.81817 0.500592 7.81817 0.912411V6.02113C7.81817 6.02292 7.81817 6.0247 7.81815 6.02649L7.81815 6.027C7.81813 6.02915 7.81811 6.0315 7.81807 6.03403C7.81799 6.03909 7.81786 6.04491 7.81765 6.05147C7.81723 6.06457 7.81651 6.08063 7.81527 6.09944C7.81281 6.13703 7.8083 6.18578 7.80011 6.24409C7.78374 6.36059 7.75253 6.51623 7.69305 6.69768C7.57332 7.06291 7.34072 7.5269 6.89564 7.97946C6.45056 8.43202 5.99425 8.66853 5.63505 8.79028C5.45661 8.85076 5.30354 8.88249 5.18897 8.89913C5.13162 8.90746 5.08368 8.91205 5.0467 8.91456C5.0282 8.91581 5.01241 8.91655 4.99953 8.91697C4.99308 8.91718 4.98736 8.91731 4.98238 8.91739C4.97989 8.91743 4.97758 8.91746 4.97547 8.91748L4.97496 8.91748C4.97321 8.91749 4.97145 8.9175 4.96969 8.9175H4.90909V13.4777H6.42425C6.79244 13.4777 7.09092 13.7812 7.09092 14.1555C7.09092 14.5299 6.79244 14.8334 6.42425 14.8334H2.06062C1.69243 14.8334 1.39395 14.5299 1.39395 14.1555C1.39395 13.7812 1.69243 13.4777 2.06062 13.4777H3.57575V8.9175H3.51514C3.51338 8.9175 3.51162 8.91749 3.50986 8.91748L3.50936 8.91748C3.50725 8.91746 3.50494 8.91743 3.50245 8.91739C3.49747 8.91731 3.49175 8.91718 3.4853 8.91697C3.47241 8.91655 3.45662 8.91581 3.43812 8.91456C3.40115 8.91205 3.3532 8.90746 3.29586 8.89913C3.18129 8.88249 3.02822 8.85076 2.84978 8.79028C2.49058 8.66853 2.03427 8.43202 1.58919 7.97946C1.14411 7.5269 0.911509 7.06291 0.791777 6.69768C0.732296 6.51623 0.701088 6.36059 0.68472 6.24409C0.676528 6.18578 0.672018 6.13703 0.669554 6.09944C0.66832 6.08063 0.667596 6.06457 0.667181 6.05147C0.666973 6.04491 0.666842 6.03909 0.666763 6.03403C0.666723 6.0315 0.666697 6.02915 0.66668 6.027L0.666677 6.02651C0.666671 6.02566 0.666666 6.02481 0.666662 6.02396L0.666658 6.02249L0.666657 6.0218C0.666657 6.02157 0.666656 6.02135 0.666656 6.02113V0.912411ZM1.99999 6.01009C2.00042 6.01634 2.00163 6.03081 2.00465 6.05236C2.01101 6.09763 2.02526 6.17308 2.05669 6.26895C2.11877 6.45834 2.24981 6.73386 2.532 7.0208C2.8142 7.30773 3.08516 7.44097 3.27141 7.5041C3.3657 7.53606 3.43991 7.55054 3.48442 7.55701C3.50562 7.56009 3.51985 7.56131 3.526 7.56175H4.95883C4.96498 7.56131 4.97921 7.56009 5.00041 7.55701C5.04492 7.55054 5.11913 7.53606 5.21341 7.5041C5.39967 7.44097 5.67063 7.30773 5.95283 7.0208C6.23502 6.73386 6.36606 6.45834 6.42814 6.26895C6.45957 6.17308 6.47382 6.09763 6.48018 6.05236C6.4832 6.03081 6.48441 6.01634 6.48484 6.01009V1.5225H1.99999V6.01009Z" fill="#2B553B" />
        </svg>
    );
    return (
        <div className={classes.addonContainer} style={{ backgroundColor: addonsPresentation?.background_color }}>
            <div className={classes.addonSvg}>
                {addonsPresentation?.icon?.url
                    ? (
                        <div className={classes.passportEligibleImage}>
                            <ResponsiveImage
                                path={addonsPresentation.icon.url}
                                alt=""
                                fullWidth
                            />
                        </div>
                    ) : renderWineSvg()}
            </div>
            <div className={classes.addonText} style={{ color: addonsPresentation?.text_color }}><strong>{addonsPresentation?.message || 'Add wine & more'} </strong></div>
        </div>
    );
};

AddonIcon.propTypes = {
    addonsPresentation: object.isRequired,
};

export default AddonIcon;
